module.exports = "//cdn.mxpnl.com/static/asset-cache/e456a9f02655ba2d53369cb9c40637c1/iron/common/assets/images/onboarding-shapes.png";